module.exports = __webpack_public_path__ + "static/media/info.ff46afb0.svg";